import React from 'react';
import Layout from '../components/layout/Layout';

function RequisitesPage() {
  return (
    <Layout>
      <section className="section-agreement">
        <div className="container">
          <h1 className="agreement__title">Реквизиты компании</h1>
          <div className="requisites">
            <p><strong>Наименование организации:</strong> ИП Ермолаева Алина Алексеевна</p>
            <p><strong>Полное наименование:</strong> Индивидуальный предприниматель Ермолаева Алина Алексеевна</p>
            <p><strong>Юридический адрес:</strong> 196626, г. Санкт-Петербург, пос. Шушары, ул. Колпинское шоссе, д. 34, корп. 1, кв. 115</p>
            <p><strong>ИНН:</strong> 302200695506</p>
            <p><strong>ОГРНИП:</strong> 321784700059356</p>
            <p><strong>E-mail:</strong> <a href="mailto:admin@sunpanda.ru">admin@sunpanda.ru</a></p>
            <p><strong>Телефон:</strong> <a href="tel:+79962757918">+7 (996) 275-79-18</a></p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default RequisitesPage;
